<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div style="height: 50px;line-height: 50px;font-size: 12px;">
			</div>
			<div class="d-flex jc-center">
				<div class="left-box">
					
					<template v-if="styleIndex==1">
						<div style="position: relative;width: 376px;height: 375px;"
						:style="'background: url('+bg1+');background-size: 100% 100%;'">
							<div style="position: absolute;width: 376px;height: 375px;filter: blur(2px);" >
							</div>
							<div  style="position: absolute;width: 376px;height: 375px;padding: 0 12px;box-sizing: border-box;z-index: 99;">
								<img style="height: 68px;width: 360px;" src="../../assets/staff/toubu.png" />
								<div class="d-flex" style="align-items: center;">
									<img v-if="userData.logo_img" style="border-radius: 50%;width: 80px;height: 80px;" :src="userData.logo_img" />
									<img v-else style="border-radius: 50%;width: 80px;height: 80px;" src="../../assets/staff/moren.png" />
									<div style="margin-left: 10px;height: 70px;">
										<div style="font-weight: 700;color: #FFFFFF;font-size: 22px;">{{userData.name||'暂无名称信息'}}</div>
										<div style="padding: 6px 13px;color: #FFFFFF;border-radius: 50px;background: #1E69FF;font-size: 12px;display: inline-block;">
											{{userData.job||'暂无职务信息'}}
										</div>
									</div>
									<div style="height: 60px;margin-left: auto;color: #FFFFFF;">
										<div style="font-size: 13px;font-weight: 700;">
											+ 添加到名片录
										</div>
									</div>
								</div>
								<div style="margin-top: 50px;width: 100%;display: flex;">
									<div style="font-size: 16px;color: #FFFFFF;">{{userData.work_phone||'暂无联系电话'}}</div>
									<div style="font-size: 16px;color: #FFFFFF;margin-left: auto;">{{userData.email||'暂无邮箱信息'}}</div>
								</div>
								<div style="position: absolute;left: 12px;right: 12px;bottom: -75px;height: 150px;background: #FFFFFF;border-radius: 6px;">
									<div style="padding: 18px 12px;box-sizing: border-box;">
										<div style="font-weight: 700;">{{userData.company||'暂无公司信息'}}</div>
										<div style="display: inline-block; padding: 6px 16px;border-radius: 50px;font-size: 12px;
										border: 2px solid #1E69FF;color: #1E69FF;margin-top: 16px;">
											{{userData.industry||'暂无信息'}}
										</div>
										<div style="font-size: 12px;display: flex;align-items: center;margin-top: 16px;">
											<img style="width: 13px;height: 16px;" src="../../assets/staff/dingwei.png" />
											<div style="font-size: 12px;margin-left: 6px;">{{userData.company_address||'暂无地址信息'}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div  class="flt-bot" style="overflow-y: scroll;height: 395px;box-sizing: border-box;padding: 90px 12px 0 12px;">
							<template v-if="contenList.length">
								<div v-for="(item,index) in contenList">
									<div  v-if="item.type==1">
										{{item.content}}
									</div>
									<div v-else>
										<img style="width: 100%;" :src="item.content" />
									</div>
								</div>
							</template>
							<template v-else>
								<div class="img-box" v-html="contents">
								</div>
							</template>
						</div>
					</template>
					<template v-else-if="styleIndex==2">
						<div class="d-flex">
							<img :src="userData.logo_img" style="width: 100%;height: 375px;" />
						</div>
						
						<div class="d-flex">
							<div class="d-flex a-center j-center" 
							style="width: 250px;height: 60px;background: #FFFFFF;">
								<div class="d-flex" style="align-items: baseline;font-weight: 700;">
									<div>
										<span style="font-size: 24px;">{{userData.name||'暂无数据'}}</span>
										<span style="margin-left: 10px;font-size: 12px;">{{userData.job||'暂无职务信息'}}</span>
									</div>
								</div>
							</div>
							<div class="d-flex j-center a-center" 
							style="flex: 1;height: 60px;background: #205DFF;font-size: 12px;font-weight: 700;color: #FFFFFF;">
								添加到名片录
							</div>
						</div>
						<div class="d-flex a-center j-sb" 
						style="box-sizing: border-box;padding: 0 12px;margin: 12px 0;">
							<div class="d-flex a-center j-center"
							style="width: 170px;height: 170px;background: #FFFFFF;border-radius: 5px;">
								<div>
									<div style="text-align: center;">
										<img style="width: 27px;height: 27px;" src="../../assets/staff/shouji.png" />
									</div>
									<div style="font-size: 12px;color: #205DFF;text-align: center;">电话</div>
									<div style="text-align: center;font-size: 15px;">{{userData.work_phone||'暂无联系电话'}}</div>
								</div>
							</div>
							<div class="d-flex a-center j-center"
							style="width: 170px;height: 170px;background: #FFFFFF;border-radius: 5px;">
								<div>
									<div style="text-align: center;">
										<img style="width: 27px;height: 27px;" src="../../assets/staff/youxiang.png" />
									</div>
									<div style="font-size: 12px;color: #205DFF;text-align: center;">邮箱</div>
									<div style="text-align: center;font-size: 15px;">{{userData.email||'暂无邮箱信息'}}</div>
								</div>
							</div>
						</div>
						<div style="padding: 0 12px;">
							<div style="height: 140px;background: #FFFFFF;border-radius: 5px;background: #FFFFFF;box-sizing: border-box;
							padding: 25px 14px;display: flex;justify-content: space-between;flex-direction: column;">
								<div style="font-weight: 700;font-size: 18px;">{{userData.company||'暂无公司信息'}}</div>
								<div>
									<div style="display: inline-block;box-sizing: border-box;padding: 5px 12px;
									border: 1px solid #FF3A3A;border-radius: 25px;font-size: 13px;color: #FF3A3A;">
										{{userData.industry||'暂无所属分类'}}
									</div>
								</div>
								<div class="d-flex a-center">
									<div class="d-flex a-center">
										<img style="width: 13px;height: 13px;" src="../../assets/staff/dizhi.png" />
									</div>
									<div style="margin-left: 5px;font-size: 12px;">{{userData.company_address||'暂无地址信息'}}</div>
								</div>
							</div>
						</div>
						<div style="box-sizing: border-box;padding: 29px 0 14px 27px;font-size: 18px;font-weight: 700;">
							企业介绍
						</div>
						<div style="box-sizing: border-box;padding: 0 12px;">
							<template v-if="contenList.length">
								<div v-for="(item,index) in contenList">
									<div  v-if="item.type==1">
										{{item.content}}
									</div>
									<div v-else>
										<img style="width: 100%;" :src="item.content" />
									</div>
								</div>
							</template>
							<template v-else>
								<div v-html="contents">
								</div>
							</template>
						</div>
					</template>
					<template v-else>
						<div style="width: 375px;height: 375px;position: relative;
						background: url(http://xy.spmall.com/image/wxxcbj.png);background-size: 100% 100%">
							<div style="position: absolute;z-index: 0;width: 375px;height: 375px;" 
							:style="'background: url('+bg2+');background-size: 100% 100%;'"></div>
							<div style="position: absolute;top: 120px;left: 0;right: 0;box-sizing: border-box;padding: 0 12px;">
								<div style="height: 140px;padding-top: 23px;flex-direction: column;display: flex;
								padding-bottom: 23px;box-sizing: border-box;padding: 0 17px;border-radius: 5px;justify-content: space-between;">
									<div class="d-flex a-center">
										<div class="d-flex a-center">
											<img style="width: 20px;height: 20px;" src="../../assets/staff/bj.png"></img>
										</div>
										<div style="margin-left: 8px;font-size: 12px;color: #FFFFFF;">编辑我的名片</div>
									</div>
									<div class="d-flex a-center" style="margin-top: 12px;">
										<div class="d-flex a-center">
											<img style="width: 20px;height: 20px;" src="../../assets/staff/dz.png"></img>
										</div>
										<div style="margin-left: 8px;font-size: 12px;color: #FFFFFF;">地址信息</div>
									</div>
									<div style="font-size: 18px;color: #FFFFFF;margin-top: 12px;">
										公司名称
									</div>
									<div style="margin-top: 12px;">
										<div 
										style="font-size: 13px;color: #FFFFFF;box-sizing: border-box;padding: 4px 14px;
										border: 1px solid #FFFFFF;
										border-radius: 25px;display: inline-block;color: #FFFFFF;">
											暂无行业信息
										</div>
									</div>
								</div>
							</div>
							<div style="position: absolute;left: 12px;right: 12px;
							box-shadow: 0px 0px 30px 0px rgba(33, 22, 19, 0.08);
							border-radius: 40px;height: 150px;bottom: -104px;background: #FFFFFF;" 
							class="d-flex">
								<div>
									<img v-if="userData.logo_img" style="width: 78px;height: 80px;border-radius: 50%;
									margin-left: 5px;margin-top: 5px;" 
									:src="userData.logo_img" ></img>
									<img v-else style="width: 78px;height: 80px;border-radius: 50%;
									margin-left: 5px;margin-top: 5px;" 
									src="../../assets/staff/moren.png" ></img>
								</div>
								<div style="margin-left: 18px;margin-top: 21px;">
									<div class="" style="font-size: 23px;">
										{{userData.name||'暂无数据'}}/{{userData.job||'暂无数据'}}
									</div>
									<div class="d-flex a-center" style="margin-top: 21px;">
										<div class="d-flex a-center">
											<img style="width: 15px;height: 15px;" src="../../assets/staff/shouji_1.png"></img>
										</div>
										<div style="font-size: 15px;margin-left: 8px;">电话：</div>
										<div style="font-size: 15px;">{{userData.work_phone||'暂无联系电话'}}</div>
									</div>
									<div class="d-flex a-center" style="margin-top: 21px;">
										<div class="d-flex a-center">
											<img style="width: 15px;height: 15px;" src="../../assets/staff/youjian.png"></img>
										</div>
										<div style="font-size: 15px;margin-left: 8px;">邮箱：</div>
										<div style="font-size: 15px;">{{userData.email||'暂无邮箱信息'}}</div>
									</div>
								</div>
							</div>
						</div>
						<div style="height: 100px;"></div>
						<div style="box-sizing: border-box;padding: 29px 0 14px 27px;font-size: 18px;font-weight: 700;">
							企业介绍
						</div>
						<div style="box-sizing: border-box;padding: 0 12px;">
							<template v-if="is_template==1">
								<div>
									<div style="width: 100%;height: 455px;position: relative;">
										<img  style="height: 455px;width: 342px!important;cursor: pointer;" :src="modelData.photo_url1" />
										<div style="position: absolute;left: 0;right: 0;bottom: 99px;">
											<div class="eipt" style="background: none;font-weight: 700;color: #FFFFFF;padding: 0 12px;box-sizing: border-box;">
												{{modelData.title1}}
											</div>
										</div>
										<div style="position: absolute;left: 0;right: 0;bottom: 19px;">
											<div class="eipt" style="color: #FFFFFF!important;padding: 0 12px;box-sizing: border-box;">
												{{modelData.brief1}}
											</div>
										</div>
									</div>
									<div>
										<div class="eipt1" style="font-weight: 700;margin-top: 7px;font-weight: 700;">{{modelData.title2}}</div>
									</div>
									<div>
										<div class="eipt1" style="background: none;color: #888888;margin-top: 5px;" >
										{{modelData.brief2}}
										</div>
									</div>
									<div>
										<img @click="productStase = true" style="width: 342px;height: 100%;margin-top: 7px;cursor: pointer;" :src="modelData.photo_url2" />
									</div>
									<div>
										<div class="eipt1"
										style="font-weight: 700;margin-top: 7px;" >{{modelData.title3}}</div>
									</div>
									<div>
										<div class="eipt1" style="color: #888888;margin-top: 5px;">{{modelData.brief3}}</div>
									</div>
									<div>
										<img @click="ysStase = true" style="width: 342px;height: 100%;margin-top: 7px;cursor: pointer;" :src="modelData.photo_url3" />
									</div>
									<div>
										<div class="eipt1" style="font-weight: 700;margin-top: 7px;font-weight: 700;">
										{{modelData.title4}}
										</div>
									</div>
									<div>
										<div class="eipt1" style="color: #888888;margin-top: 5px;">
										{{modelData.brief4}}
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<template v-if="contenList.length">
									<div v-for="(item,index) in contenList">
										<div  v-if="item.type==1">
											{{item.content}}
										</div>
										<div v-else>
											<img style="width: 100%;" :src="item.content" />
										</div>
									</div>
								</template>
								<template v-else>
									<div v-html="contents">
									</div>
								</template>
							</template>
							
						</div>
					</template>
				</div>
				<div class="right-box">
					<div style="width: 460px;height: 169px;background: #FFFFFF;border-radius: 6px;padding: 30px 26px;box-sizing: border-box;
					display: flex;flex-direction: column;justify-content: space-between;">
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">员工姓名：</div>
							<el-input v-model="userData.name" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">员工编号：</div>
							<el-input v-model="userData.number" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">职务：</div>
							<el-input v-model="userData.job" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
					</div>
					<div style="width: 460px;height: 60px;background: #FFFFFF;border-radius: 6px;padding: 30px 26px;box-sizing: border-box;
					display: flex;align-items: center;margin-top: 15px;">
						<!-- <div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">所属公司：</div>
							<el-input v-model="userData.company" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">公司地址：</div>
							<el-input v-model="userData.company_address" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div> -->
						<div style="font-size: 12px;font-weight: 700;">所属公司：</div>
						<el-select style="width: 210px; margin-left: auto;"
						size="small" v-model="userData.company" placeholder="请选择">
							<el-option
							  v-for="item in branchData"
							  :key="item.company_name"
							  :label="item.company_name"
							  :value="item.company_name">
							</el-option>
						</el-select>
<!-- 						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">所属行业：</div>
							<el-input v-model="userData.company_address" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div> -->
					</div>
					<div style="width: 460px;height: 169px;background: #FFFFFF;border-radius: 6px;padding: 30px 26px;box-sizing: border-box;
					display: flex;flex-direction: column;justify-content: space-between;margin-top: 15px;">
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">微信绑定号码：</div>
							<el-input v-model="userData.micro_number" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">其他号码(选填)：</div>
							<el-input v-model="userData.work_phone" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">邮箱(选填)：</div>
							<el-input v-model="userData.email" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
					</div>
					<div style="width: 460px;height: 169px;background: #FFFFFF;border-radius: 6px;padding: 30px 26px;box-sizing: border-box;
					display: flex;flex-direction: column;justify-content: space-between;margin-top: 15px;">
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">员工状态：</div>
							<el-select v-model="userData.staff_status" placeholder="请选择" 
							style="width: 210px; margin-left: auto;" size="mini">
							    <el-option
							      v-for="item in options"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							</el-select>
						</div>
						<template v-if="userData.staff_status == 1">
							<div style="display: flex;align-items: center;">
								<div style="font-size: 12px;font-weight: 700;">请假时间：</div>
								<el-date-picker style="width: 210px; margin-left: auto;" size="mini"
								      v-model="userData.leave_time"
								      type="date"
								      placeholder="请选择">
								</el-date-picker>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="font-size: 12px;font-weight: 700;">复岗时间：</div>
								<el-date-picker style="width: 210px; margin-left: auto;" size="mini"
								      v-model="userData.resume_work"
								      type="date"
								      placeholder="请选择">
								</el-date-picker>
							</div>
						</template>
						<template v-if="userData.staff_status == 3">
							<div style="display: flex;align-items: center;">
								<div style="font-size: 12px;font-weight: 700;">离职时间：</div>
								<el-date-picker style="width: 210px; margin-left: auto;" size="mini"
								      v-model="userData.quit_work"
								      type="date"
								      placeholder="请选择">
								</el-date-picker>
							</div>
						</template>
					</div>
					<div style="width: 460px;min-height: 192px;background: #FFFFFF;border-radius: 6px;
					padding: 30px 26px;box-sizing: border-box;margin-top: 15px;">
						<div style="display: flex;align-items: center;">
							<div style="font-size: 12px;font-weight: 700;">当前职务范围(选填)：</div>
							<el-radio v-model="userData.job_scope_status" label="0">企业内部显示</el-radio>
							<el-radio v-model="userData.job_scope_status" label="1">全部显示</el-radio>
						</div>
						<div style="margin-top: 15px;">
							<el-input v-model="userData.job_scope_remark" placeholder="请输入员工服务范围" 
							type="textarea" :autosize="{ minRows: 5, maxRows: 6}" maxlength="100" show-word-limit>
								
							</el-input>
						</div>
					</div>
					<div style="width: 460px;height: 60px;background: #FFFFFF;border-radius: 6px;
					display: flex;margin-top: 15px;align-items: center;padding: 0 26px;box-sizing: border-box;">
						<div style="display: flex;align-items: center;width: 100%;">
							<div style="font-size: 12px;font-weight: 700;">备注：</div>
							<el-input v-model="userData.remark" style="width: 210px; margin-left: auto;" size="mini"></el-input>
						</div>
					</div>
					<!-- <div style="width: 460px;height: 60px;background: #FFFFFF;border-radius: 6px;padding: 0px 26px;box-sizing: border-box;
					display: flex;flex-direction: column;justify-content: space-between;margin-top: 15px;">
						<div style="display: flex;align-items: center;height: 60px;">
							<div style="font-size: 12px;font-weight: 700;">名片样式：</div>
							<el-select size="mini" v-model="userData.card_style_id" style="width: 210px; margin-left: auto;" placeholder="请选择">
							    <el-option
							      v-for="item in typeList"
							      :key="item.id"
							      :label="item.style_name"
							      :value="item.id">
							    </el-option>
							</el-select>
						</div>
					</div> -->
					<div v-if="styleIndex==2" style="width: 460px;height: 190px;background: #FFFFFF;border-radius: 6px;padding: 0px 26px;box-sizing: border-box;
					display: flex;flex-direction: column;justify-content: space-between;margin-top: 15px;">
						<div style="display: flex;align-items: center;height: 180px;">
							<div style="font-size: 12px;font-weight: 700;">用户头像：</div>
							<el-upload
							  class="avatar-uploader w-100"
							  action="upload"
							  :show-file-list="false"
							  :on-change="getVideo"
							  :http-request="()=>{}"
							  accept='.png,.jpeg,.jpg'
							  style="margin-left: auto;width: 120px;height: 120px;background: #E7E7E7;border-radius: 6px;
							  display: flex;align-items: center;justify-content: center;color: #666666;font-size: 13px;cursor: pointer;">
								<img v-if="userData.logo_img" style="width: 120px;height: 120px;" :src="userData.logo_img" />
							  	<div v-else style="width: 80px;height: 120px;text-align: center!important;line-height: 120px;">相册/上传</div>
							</el-upload>
							
						</div>
						
					</div>
				</div>
			</div>
			<div v-if="rows.state != 1" class="d-flex j-center a-center w-100" style="margin-top: 30px;background: #FFFFFF;padding: 15px 0;">
				
				<template v-if="rows.state == 2">
					<div @click="reset()" class="d-flex j-center a-center"
					style="width: 114px;height: 26px;margin-left: 36px;box-sizing: border-box;border: 2px solid #333333;
					border-radius: 6px;color: #333333;cursor: pointer;font-size: 12px;">
						删除
					</div>
					<div @click="staff_card_contact_set_or_del()" class="d-flex j-center a-center"
					style="width: 114px;height: 26px;margin-left: 36px;box-sizing: border-box;border: 2px solid #333333;
					border-radius: 6px;color: #333333;cursor: pointer;font-size: 12px;">
						设为企业联系人
					</div>
					<div @click="showCard=true" class="d-flex j-center a-center"
					style="width: 114px;height: 26px;margin-left: 36px;box-sizing: border-box;border: 2px solid #333333;
					border-radius: 6px;color: #333333;cursor: pointer;font-size: 12px;">
						推送名片
					</div>
				</template>
				<div @click="staff_card_add()" class="d-flex j-center a-center"
				style="width: 114px;height: 26px;background: #1E69FF;margin-left: 36px;
				border-radius: 6px;color: #FFFFFF;cursor: pointer;font-size: 12px;">
					发布
				</div>
			</div>
			<div style="margin-top: 15px;font-size: 10px;color: #1E69FF;display: flex;align-items: center;justify-content: center;">
				<div style="color: #FFFFFF;width: 15px;height: 15px;display: flex;align-items: center;justify-content: center;border-radius: 50%;background: #1E69FF;">
					!
				</div>
				<div style="margin-left: 5px;">
					企业联系人说明：加入到企业联系人的名片将在公司的企业微网站（联系我们）中显示，最多可设置6人
				</div>
			</div>
		</div>
		<el-dialog
		  :visible.sync="showCard"
		  width="1170px"
		  center>
		  <div style="display: flex;align-items: center;justify-content: center;position: relative;" slot="title">
				<div>选择接收名片的客户</div>
				<div style="position: absolute;right: 100px;">
					<el-input v-model="keywords" size="small" style="width: 300px;" placeholder="请输入搜索关键字" class="input-with-select">
						<el-button @click="staff_card_list" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
		  </div>
		  <div style="padding: 0 20px 20px 20px;background: #F8F8F8;height: 560px;overflow-y: scroll;">
			  <el-checkbox-group v-model="checkList">
				  <label v-for="(item,index) in tableDatas" :key="index" 
				  style="display: flex;height: 50px;align-items: center;font-size: 12px;cursor: pointer;justify-content: space-between;">
					<el-checkbox :label="item.id"><br></el-checkbox>
					<div style="width: 60px;text-align: center;width: 16%;">{{item.number}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.company}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.work_phone}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.name}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.job}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.micro_number}}</div>
				  </label>
			  </el-checkbox-group>
		  </div>
		  <div class="d-flex a-center j-center" style="margin-top: 20px;">
				<div @click="showCard=false" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #cccccc;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;">
					取消
				</div>
				<div @click="staff_forward()" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: 30px;">
					确定推送
				</div>
		  </div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				back:require('../../assets/Home/logo.png'),
				bg2:require('../../assets/staff/bg2.png'),
				bg1:require('../../assets/staff/bg1.png'),
				centerDialogVisible: false,
				showfile:false,
				ishowVideo:false,
				//广告图
				adBg:'',
				tempBg:'',
				tabState:true,
				mobile:'',
				address:'',
				tempMobile:'',
				tempAddress:'',
				contents:'',
				typeList:[],
				rows:'',
				userData:{
					name:'',//--员工姓名
					number:'',//--员工编号
					job:'',//--职务
					company:'',//--所属公司名称
					company_address:'',//--所属公司地址
					logo_img:'',//--头像base64编码
					micro_number:'',//--微站绑定号码
					work_phone:'',//--工作电话
					email:'',//--邮箱
					card_style_id:1,//--选填 ，名片样式id，不填默认1(样式一)
					industry:'',
					staff_status: '0',
					leave_time:'',
					resume_work:'',
					job_scope_status:'1',
					job_scope_remark:'',
					remark:'',
					quit_work:''
				},
				contenList:[],
				styleIndex:1,
				branchData:[],
				options: [{
				  value: '0',
				  label: '正常'
				}, {
				  value: '1',
				  label: '休假'
				}, {
				  value: '2',
				  label: '调岗'
				},{
				  value: '3',
				  label: '离职'
				}],
				showCard:false,
				tableDatas:[],
				checkList:[],
				keywords:'',
				is_template:'',
				modelData:''
			};
		},
		created() {
			if(localStorage.getItem('styleIndex')){
				this.styleIndex = localStorage.getItem('styleIndex')
				this.userData.card_style_id = this.styleIndex
				console.log(this.userData.card_style_id);
			}
			this.rows = this.$route.query
			console.log(this.rows);
			this.business_intro()
			this.get_card_style_type()
			this.staff_card_info(this.$route.query.id)
			this.leave_message_list()
			this.staff_card_list()
		},
		methods: {
			staff_forward(){
				if(this.checkList.length==0){
					this.$message({
						showClose: false,
						message: '请选择推送客户',
						type: 'error',
						offset: 350
					})
					return
				}
				let param = {
					act : 'staff_forward',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type : 1,
					staff_ids : this.userData.id,
					receive_staff_ids : this.checkList.join(','),
				}
				this.$api.staff_card_list(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '推送成功',
							type: 'success',
							offset: 350
						})
						this.showCard = false
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			staff_card_list(){
				let param = {
					act : 'staff_card_customer_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keywords,
					page : 1,
					size : 99
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.tableDatas = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableDatas.push({...item,is_confirm:item.status==1?true:false})
						})
					}
				})
			},
			staff_card_contact_set_or_del(){
				let params = {
					act:'staff_card_contact_set_or_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids:this.userData.id,
					sign:1
				}
				this.$api.branch_office_list(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '设置成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//获取留言列表
			leave_message_list(){
				
				let params = {
					act:'branch_office_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:20,
					page:1
				}
				this.$api.branch_office_list(params).then((res)=>{
					if(res.code == 0){
						this.branchData = res.data	
					}
					let userinfo = JSON.parse(localStorage.getItem('user_info'))
					this.branchData.unshift({company_name:userinfo.company_name,id:localStorage.getItem('ru_id')})
					if(this.branchData.length == 1){
						this.userData.company = this.branchData[0].company_name
					}
				})
			},
			//获取模板列表
			get_card_style_type(){
				
				let aprams = {
					act : 'get_card_style_type',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				
				this.$api.get_card_style_type(aprams).then((res)=>{
					if(res.code == 0){
						this.typeList = res.data
					}
				})
			},
			//获取背景图base64
			getAdBg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.adBg = res
				})
			},
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			//获取企业介绍
			business_intro(){
				let params = {
					act:'business_intro',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.business_intro(params).then((res)=>{
					if(res.code == 0){
						if(typeof res.data.business_intro == 'object'){
							this.contenList = res.data.business_intro
						}else{
							this.contents = res.data.business_intro
						}
						this.is_template = res.data.is_template
						this.modelData = res.data.business_intro
					}
				})
			},
			//获取地址和电话信息
			business_cooperation(){
				let params = {
					act:'business_cooperation',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				
				this.$api.business_cooperation(params).then((res)=>{
					if(res.code == 0){
						this.tempAddress = res.data.business_address||'暂无地址信息'
						this.tempMobile = res.data.kf_tel||'暂无联系方式'
					}
				})
			},
			//发布企业基本信息
			staff_card_add(){
				
				let company_ru_id = ''
				this.branchData.forEach((item)=>{
					if(item.company_name == this.userData.company){
						company_ru_id = item.id
					}
				})
				if(this.userData.name == ''){
					this.$message({
						showClose: false,
						message: '员工姓名不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.userData.number == ''){
					this.$message({
						showClose: false,
						message: '员工编号不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.userData.job == ''){
					this.$message({
						showClose: false,
						message: '职务不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.userData.company == ''){
					this.$message({
						showClose: false,
						message: '所属公司不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.userData.micro_number == ''){
					this.$message({
						showClose: false,
						message: '微站绑定号码不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				
				let params = {
					act:this.rows.state==2?'staff_card_edit':'staff_card_add',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.userData,
					leave_time:this.userData.leave_time?this.formatDate(this.userData.leave_time):'',
					resume_work:this.userData.resume_work?this.formatDate(this.userData.resume_work):'',
					quit_work:this.userData.quit_work?this.formatDate(this.userData.quit_work):'',
					logo_img:this.userData.logo_img.indexOf('http') != -1?'':this.userData.logo_img,
					company_ru_id:company_ru_id||localStorage.getItem('ru_id'),
					company_p_id:company_ru_id == localStorage.getItem('ru_id')?0:localStorage.getItem('ru_id')
				}
				this.$api.staff_card_add(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功可以继续添加员工信息',
							type: 'success',
							offset: 350
						})
						// this.reset()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
				
			},
			formatDate(val){
				let data = new Date(val)
				let year = data.getFullYear(); 
				let month = data.getMonth() + 1; 
				let day = data.getDate(); 
				return year + "-" + month + "-" + day
			},
			reset(){
				this.userData = {
					name:'',//--员工姓名
					number:'',//--员工编号
					job:'',//--职务
					company:'',//--所属公司名称
					company_address:'',//--所属公司地址
					logo_img:'',//--头像base64编码
					micro_number:'',//--微站绑定号码
					work_phone:'',//--工作电话
					email:'',//--邮箱
					card_style_id:'',//--选填 ，名片样式id，不填默认1(样式一)
					industry:''
				}
			},
			getVideo(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.userData.logo_img = res
				})
			},
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			//获取名片详情
			staff_card_info(id){
				
				let params = {
					act:'staff_card_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:id
				}
				
				this.$api.staff_card_info(params).then((res)=>{
					if(res.code == 0){
						this.userData = res.data
					}
				})
			}
		}
	};
</script>
<style>
	.el-dialog__wrapper{
		z-index: 999!important;
	}
	.v-modal{
		z-index: 998!important;
	}
	.img-box img{
		width: 100%!important;
	}
</style>
<style scoped>
	.flt-bot::-webkit-scrollbar{
		display: none;
	}
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		flex-wrap: wrap;
	}
	.left-box{
		box-sizing: border-box;
		width: 396px;
		height: 790px;
		border-radius: 14px;
		border: 10px solid #0C275E;
		position: relative;
		background: #F5F5F5;
		overflow-y: scroll;
	}
	.left-box::-webkit-scrollbar{
		display: none;
	}
	.right-box{
		width: 460px;
		/* height: 790px; */
		/* border: 2px solid #BBBBBB; */
		border-radius: 6px;
		box-sizing: border-box;
		margin-left: 99px;
		/* overflow-y: scroll; */
	}
	.right-box::-webkit-scrollbar{
		display: none;
	}
	.button-box{
		margin-top: 300px;
		width: 60px;
		height: 90px;
		background: #F2F2F2;
		box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
		border-radius: 0px 10px 10px 0px;
		border-left: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.img-box::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-box::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.tabbar-box{
		height: 45px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0px 0px 10px 10px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		box-sizing: border-box;
		padding: 4px 28px;
	}
</style>
